import { apiRequest } from "./axiosInstance";


export const getCompanyReports = async (params)=>{
    const response = await apiRequest({
        url: "/reports/companyRevenue",
        method: "GET",
        params:params
      });
      return response?.data
}

export const getTenantReports = async (params)=>{
    const response = await apiRequest({
        url: "/reports/tenantRevenue",
        method: "GET",
        params:params
      });
      return response?.data
}

export const getDashReports = async (params)=>{
    const response = await apiRequest({
        url: "/reports/getDashBoardReports",
        method: "GET",
        params:params
      });
      return response?.data
}

export const getRevenueDownload = async (params)=>{
    const response = await apiRequest({
        url: "/reports/downloadRevenueReport",
        method: "GET",
        params:params
      });
      return response?.data
}


export const staffReportApi = async (params)=>{
    const response = await apiRequest({
        url: "/reports/staffReport",
        method: "GET",
        params:params
      });
      return response?.data
}

export const getDashboardReportFrontApi = async (params)=>{
    const response = await apiRequest({
        url: "/reports/getDashboardReportFront",
        method: "GET",
        params:params
      });
      return response?.data
}
export const getTenantDashboardReportApi = async (params)=>{
    const response = await apiRequest({
        url: "/reports/getTenantDashboardReport",
        method: "GET",
        params:params
      });
      return response?.data
}
